<!--<c-footer>-->
  <div>
    <a href="https://app.irms.cloudns.biz/" target="_blank">IRMS</a>
    <span> &copy; 2023 Taj Hotels, Mumbai</span>
  </div>
  <div class="ms-auto">
    Powered by
    <a href="https://app.irms.cloudns.biz/" target="_blank">
      <span> UCI Consultancy Services</span>
    </a>
  </div>
<!--</c-footer>-->
